/**
 * Created by richardlovejoy on 2/13/17.
 */

// The view units here are in 3D model space, based on the playcanvas model:
// https://playcanvas.com/editor/scene/496460

// physics scaling
const VIEW_UNITS_PER_METER = 11.915;
const VIEW_UNITS_PER_INCH = 0.1436985919350072;

const viewToPhysics = function(value) {
  return value / VIEW_UNITS_PER_METER;
};

const physicsToView = function(value) {
  return value * VIEW_UNITS_PER_METER;
};

const viewPositionToPhysics = function(position, $target) {

  var target = (typeof $target !== 'undefined') ? $target : {};

  target.x = viewToPhysics(position.x);
  target.y = viewToPhysics(position.y);
  target.z = viewToPhysics(position.z);

  return target;
};

const physicsPositionToView = function(position, $target) {

  var target = (typeof $target !== 'undefined') ? $target : {};

  target.x = physicsToView(position.x);
  target.y = physicsToView(position.y);
  target.z = physicsToView(position.z);

  return target;

};

const MachineConstants = {

  // positions
  LEFT_OUTER_WALL: -4.1,
  RIGHT_OUTER_WALL: 4.1,
  LEFT_RAMP_WALL: {x: -2.8, y: -4, z: 7},
  RIGHT_RAMP_WALL: {x: 2.8, y: -4, z: 7},
  FRONT_RAMP: {x: 0, y: -4.577, z: 7.5},
  BACK_RAMP: {x: 0, y: 1.4, z: -11},
  BACK_WALL: {x: 0, y: 7.0, z: -14},
  CENTER_CUP: {x: 0, y: 1.244, z: -9.681},
  CENTER_CUP_RADIUS: 6*VIEW_UNITS_PER_INCH,
  CENTER_HOLE: {x: 0, y: 0.688, z: -10.17},
  LARGE_CENTER_CUP: {x: 0, y: 1.382, z: -9.806},
  LARGE_CENTER_CUP_RADIUS: 18.5*VIEW_UNITS_PER_INCH,
  LARGE_CENTER_HOLE: {x: 0, y: -0.674, z: -8.955},
  CENTER_UPPER_CUP: {x: 0, y: 2.753, z: -11.038},
  CENTER_UPPER_CUP_RADIUS: 5.75*VIEW_UNITS_PER_INCH,
  CENTER_UPPER_HOLE: {x: 0, y: 1.998, z: -11.597},
  MIDDLE_TOP_CUP: {x: 0, y: 4.101, z: -12.257},
  MIDDLE_TOP_CUP_RADIUS: 5.5*VIEW_UNITS_PER_INCH,
  MIDDLE_TOP_HOLE: {x: 0, y: 3.642, z: -12.762},
  LEFT_TOP_CUP: {x: -3.092, y: 4.257, z: -12.875},
  LEFT_TOP_CUP_RADIUS: 5*VIEW_UNITS_PER_INCH,
  LEFT_TOP_HOLE: {x: -3.048, y: 3.889, z: -13.076},
  RIGHT_TOP_CUP: {x: 3.092, y: 4.257, z: -12.875},
  RIGHT_TOP_CUP_RADIUS: 5*VIEW_UNITS_PER_INCH,
  RIGHT_TOP_HOLE: {x: 3.048, y: 3.889, z: -13.076},
  BIG_RING: {x: 0, y: 1.668, z: -10.057},
  BIG_RING_RADIUS: 28.8*VIEW_UNITS_PER_INCH,
  BIG_RING_HOLE: {x: 0, y: -1.997, z: -8.326},
  THROW_START_BALL_PLACEMENT: {x: 0, y: -4.8, z: 19},//.65
  DISPENSER_END_BALL_PLACEMENT: {x: 3.75, y: -4.311, z: 17.743},
  DISPENSER_START_BALL_PLACEMENT_DISTANCE: 9,
  //BALL_CUP_CHECK_POINT: {x: 0, y: -0.746, z: -5.916},
  BALL_CUP_CHECK_POINT: {x: 0, y: -2.315, z: -7.566},
  RAMP_BLOCKER: {x: 0, y: -3.5, z: -7.0},

  SMALL_CUP_HEIGHT: 4.5*VIEW_UNITS_PER_INCH,
  CUP_HEIGHT: 4.75*VIEW_UNITS_PER_INCH,

  FRONT_RAMP_END: 20.4,
  LAUNCH_RAMP_START: -3,

  //
  WALL_THICKNESS: 5,
  BALL_RADIUS: 0.4729,
  BALL_WEIGHT: 0.175,  // 0.165kg
  FRONT_RAMP_SLOPE: 3.494 * Math.PI/180,
  LAUNCH_RAMP_SLOPE: 78 * Math.PI/180,
  BACK_RAMP_SLOPE: 48 * Math.PI/180,


};


export {
  MachineConstants,
  viewToPhysics,
  viewPositionToPhysics,
  physicsToView,
  physicsPositionToView
};



// WEBPACK FOOTER //
// ./app/src/constants/MachineConstants.js